<template>
  <div class="bg-white my-2.5 px-5 py-10 relative"
    style="font-size: 22px; min-height: 200px; border-radius: 9px; font-family: 'Open Sans', sans-serif; color: #2A4067!important;">
    <span class="absolute cursor-pointer" @click="copy(JSON.stringify(payload))"
      style="right: 20px;top: 10px;">
      <CopyIcon :isActive="checkIfIsEqual(JSON.stringify(payload))" title="Copy hash"
        class="min-w-[16px] h-[19px] inline-block align-middle" />
      <span class="text-[#2699FB] font-jost-regular inline-block text-[18px] ml-1.5">Copy content</span>
    </span>
    <vue-json-pretty v-if="payload" :virtual="virtualFlag" :data="payload" :show-line="showLine"
      :collapsed-on-click-brackets="collapsedOnClickBrackets" class="overflow-x-auto" />
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import string from "@/helpers/string";

import CopyIcon from "@/components/svg/CopyIcon.vue";

export default {
  name: 'PayloadJson',
  components: {
    VueJsonPretty,
    CopyIcon
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copied: '',
      virtualFlag: false,   // vue-json-pretty setting
      showLine: true,
      collapsedOnClickBrackets: true,
    }
  },
  computed: {
    // Your computed properties here
  },
  methods: {
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
  }
}
</script>

<style scoped>
/* Your component's styles here */
</style>
